// src/components/Tables/TableComponent.js
import { useState } from "react";
import Loader from "../loader";

const SupportTableComponent = ({ data, isImage = false, page }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };
  return (
    <div className="py-6">
      <table className="min-w-full border-collapse bg-white rounded-lg shadow-md overflow-hidden">
        <thead className="bg-blue_primary">
          <tr>
            <th className="py-3 px-4 text-left text-sm font-medium text-white uppercase tracking-wider">
              Name
            </th>
            <th className="py-3 px-4 text-left text-sm font-medium text-white uppercase tracking-wider">
              {page == "feedback" ? "Customer Feedback" : "Description"}
            </th>
            <th className="py-3 px-4 text-left text-sm font-medium text-white uppercase tracking-wider">
              Mobile Number
            </th>
            {isImage && (
              <th className="py-3 px-4 text-left text-sm font-medium text-white uppercase tracking-wider">
                Image
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {data?.length ? data.map((item, index) => (
            <tr
              key={index}
              className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
            >
              <td className="py-1.5 px-3 text-xs text-gray-800 border-t whitespace-nowrap">
                {item?.user?.full_name ? item?.user?.full_name : item?.name}
              </td>
              <td className="py-1.5 px-3 text-xs text-gray-800 border-t whitespace-nowrap">
                {item.description}
              </td>
              <td className="py-1.5 px-3 text-xs text-gray-800 border-t whitespace-nowrap">
                {item?.user?.phone ? item?.user?.phone : item?.phone}
              </td>
              {isImage && (
                <td className="py-1.5 px-3 text-xs text-gray-800 border-t flex flex-wrap">
                  {item.images.length > 0 ? (
                    item.images.map((image, imgIndex) => (
                      <img
                        key={imgIndex}
                        src={image}
                        alt={`Image ${imgIndex + 1}`}
                        onClick={() => handleImageClick(image)}
                        className="w-[70px] h-[70px] object-cover rounded-[10px] shadow-md cursor-pointer mr-2"
                      />
                    ))
                  ) : (
                    <span>No images available</span>
                  )}
                </td>
              )}
            </tr>
          )) : <Loader/>}
        </tbody>
      </table>

      {selectedImage && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center bg-gray-500 bg-opacity-75">
          <div className="relative w-fit h-full">
            <div
              className="mx-auto flex w-[35px] h-[35px] absolute right-4 top-4 flex-shrink-0 items-center justify-center rounded-full bg-red-100 cursor-pointer"
              onClick={handleCloseImageModal}
            >
              <svg
                className="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 6l12 12M6 18L18 6"
                />
              </svg>
            </div>
            <img
              src={selectedImage}
              alt="Selected"
              className="max-w-[100%] max-h-[100%] object-contain cursor-pointer"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SupportTableComponent;
